const connList = {
    'disactivated': {
        text: '未接続設定',
        description: {
            home: '自宅PCのアプリにて接続設定がされていません',
            office: '「職場用PCアプリ」にて「接続設定」が行われていません。'
        },
        textClass: 'disabledBack--text',
        color: 'disabledBack',
        icon: 'mdi-close-circle',
        img: require('@/assets/connections/disactivated.png')
    },
    'forbidden': {
        text: '接続禁止',
        description: {
            home: '組織設定もしくは職場PCアプリにて自宅PCからシステムへの接続が禁止されています',
            office: '職場用PCへの接続を禁止する設定が行われています。'
        },
        textClass: 'error--text',
        color: 'error',
        icon: 'mdi-cancel',
        img: require('@/assets/connections/forbidden.png')
    },
    'vpn_disconnected': {
        text: '接続不可',
        description: {
            home: '自宅PCからシステムへVPN接続が出来ません',
            office: '職場用PCからシステムへ接続が出来ません。　'
        },
        textClass: 'disabledBack--text',
        color: 'disabledBack',
        icon: 'mdi-close-circle',
        img: require('@/assets/connections/vpn_disconnected.png')
    },
    'vpn_connected': {
        text: '接続可',
        description: {
            home: '自宅PCはシステムへ接続可能です',
            office: 'システムから職場用PCへ接続可能です。'
        },
        textClass: 'primary--text',
        color: 'primary',
        icon: 'mdi-pause-circle-outline',
        img: require('@/assets/connections/vpn_connected.png')
    },
    'rdp_connected': {
        text: '接続中',
        description: {
            home: '自宅PCから職場PCへ接続中です',
            office: '自宅用PCから職場用PCへ接続中です。'
        },
        textClass: 'primary--text',
        color: 'primary',
        icon: 'mdi-check-circle',
        img: require('@/assets/connections/rdp_connected.png')
    },
    getConnColor: function(connection_status){
        return this[connection_status] ? this[connection_status].color : '';
    },
    getConnText: function(connection_status){
        return this[connection_status] ? this[connection_status].text : '';
    },
    getConnDescriptionHome: function(connection_status){
        return this[connection_status] ? this[connection_status].description.home : '';
    },
    getConnDescriptionOffice: function(connection_status){
        return this[connection_status] ? this[connection_status].description.office : '';
    },
    getConnIcon: function(connection_status){
        return this[connection_status] ? this[connection_status].icon : '';
    },
    getConnImage: function(connection_status){
        return this[connection_status] ? this[connection_status].img : '';
    },
    getConnTextClass: function(connection_status){
        return this[connection_status] ? this[connection_status].textClass : '';
    },

    isConnectRdp: function(connection_status){
        return connection_status == 'rdp_connected';
    },
    isConnectVpn: function(connection_status){
        return connection_status == 'vpn_connected';
    },
    isForbidden: function(connection_status){
        return connection_status == 'forbidden';
    },
    isNotConnected: function(connection_status){
        return ! (this.isConnectRdp || this.isConnectVpn)
    }
}
export default ({ app }, inject) => {
    inject('userConnectionStatusList', connList);
}